export default __webpack_public_path__ + "static/media/skype.76a75022.svg";